import styled from "styled-components";

export const ExternalLink = styled.a``;

ExternalLink.defaultProps = {
	rel: "noopener noreferrer",
	target: "_blank",
};
